import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetailsiteinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(7 5)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M44 46l6 9H0l6-9"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 37.9,
				cy: 4.1,
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 4,
				ry: 4.1
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M22 11.8l3.8 3.7c1 .9 2.5.8 3.4-.1l3-3c.6-.6 1.4-1 2.3-1h6.7c.6 0 1.5.6 1.6 1.5L44 24H31l1.3-6"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 22,
				y: 24,
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 2,
				transform: "rotate(180 25 35)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M11.2 24H6.8a.8.8 0 0 1-.8-.8V12.8c0-.4.4-.8.8-.8h4.4c.4 0 .8.4.8.8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 8,
				height: 2,
				x: 5,
				y: 8,
				fill: "currentColor",
				rx: .8
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 5,
				x: 13,
				y: 19,
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: .8
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 8,
				height: 2,
				x: 12,
				y: 15,
				fill: "currentColor",
				rx: .8
			})
		]
	})
});
export default SvgRetailsiteinline;
